export enum CheckoutMode {
  subscription = "subscription",
  payment = "payment",
}

export interface CheckoutSessionBody {
  email: string,
  mode: CheckoutMode,
  price_id: string
  coupon_code?: string,
  metadata?: any,
  discounts?: Array<string>,
  cancel_url?: string,
  customer_id?: string
}

export const defaultSubscriptionPriceId = "classic-one-year";
